const createJoinPath = origin => path => (new URL(path, origin));

export { createJoinPath };
//# sourceMappingURL=index.js.map
